module.exports = __webpack_public_path__ + "img/1546281391.952d04b2.jpg";